import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { ProductShell } from "./shell/ProductShell";

function enableAutoOpen() {
  if (typeof Office === "undefined" || !Office.addin?.setStartupBehavior) {
    return;
  }
  try {
    Office.addin.setStartupBehavior(Office.StartupBehavior.load);
  } catch {
    // Silently ignore on unsupported platforms.
  }
}

if (typeof Office !== "undefined" && typeof Office.onReady === "function") {
  Office.onReady().then(enableAutoOpen).catch(() => {});
}

const App = lazy(() => import("./app/App").then((m) => ({ default: m.App })));
const DetailDialogPage = lazy(() =>
  import("./app/DetailDialogPage").then((m) => ({ default: m.DetailDialogPage }))
);
const DocumentDialogPage = lazy(() =>
  import("./app/DocumentDialogPage").then((m) => ({ default: m.DocumentDialogPage }))
);
const ContactDialogPage = lazy(() =>
  import("./app/ContactDialogPage").then((m) => ({ default: m.ContactDialogPage }))
);
const PromptSuggestionsDialogPage = lazy(() =>
  import("./app/PromptSuggestionsDialogPage").then((m) => ({
    default: m.PromptSuggestionsDialogPage
  }))
);

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

const view = new URLSearchParams(window.location.search).get("view");
const isDetailDialog = view === "detail";
const isDocumentDialog = view === "document";
const isContactDialog = view === "contact";
const isPromptSuggestionsDialog = view === "prompt-suggestions";

function DetailDialogFallback() {
  return (
    <div className="detail-dialog-page" role="status" aria-live="polite">
      <div className="detail-dialog-topbar">
        <div className="detail-dialog-title">Chi tiết</div>
      </div>
      <div className="detail-dialog-body">
        <p className="ai-search-detail-loading">Đang mở chi tiết…</p>
      </div>
    </div>
  );
}

createRoot(root).render(
  <StrictMode>
    <Suspense
      fallback={
        isDetailDialog || isDocumentDialog || isContactDialog ? <DetailDialogFallback /> : null
      }
    >
      {isDetailDialog ? (
        <DetailDialogPage />
      ) : isDocumentDialog ? (
        <DocumentDialogPage />
      ) : isContactDialog ? (
        <ContactDialogPage />
      ) : isPromptSuggestionsDialog ? (
        <PromptSuggestionsDialogPage />
      ) : (
        <ProductShell>
          <App />
        </ProductShell>
      )}
    </Suspense>
  </StrictMode>
);
